// extracted by mini-css-extract-plugin
export default {"link":"linkButton_link__kCLUW","active":"linkButton_active__hqtSb"};